import { useEffect } from 'react';

import useEffectCallback from './useEffectCallback';

export enum UseWindowMessageCaller {
  LumaBot = 'lh:lumabot',
}

/**
 * Subscribe to window message events
 *
 * @param cb
 * @param enabled
 *
 * @example
 * useWindowMessage((event) => {
 *   console.log(`message received: ${event.data}`);
 * });
 */
export default function useWindowMessage(cb: (event: MessageEvent) => void, enabled: boolean = true) {
  const safeCb = useEffectCallback(cb);

  useEffect(() => {
    const onMessage = (event: MessageEvent) => {
      if (!enabled) return;

      // Check sender origin to be trusted
      if (window.location.href.indexOf(event.origin) !== 0) return;

      safeCb(event);
    };

    if (!enabled) return;

    if (window.addEventListener) {
      window.addEventListener('message', onMessage, false);
    } else if ((window as any).attachEvent) {
      (window as any).attachEvent('onmessage', onMessage, false);
    }

    return () => {
      if (window.removeEventListener) {
        window.removeEventListener('message', onMessage, false);
      } else if ((window as any).detachEvent) {
        (window as any).detachEvent('onmessage', onMessage, false);
      }
    };
  }, [enabled, safeCb]);
}
